import { MultiSelect } from "primereact/multiselect";

const MultiSelectTemplate = (options, array) => {
    return (
        <MultiSelect
            value={options.value}
            options={array}
            onChange={(e) => options.filterApplyCallback(e.value)}
            optionLabel="label"
            maxSelectedLabels={1}
            selectedItemsLabel="{0} вибрано"
            className="p-column-filter"
            style={{ minWidth: '10rem' }}
        />
    );
};

export default MultiSelectTemplate;